module.exports = __webpack_public_path__ + "img/telegram.f647f49d.svg";